import PosthogSettings from "./PosthogSettings";

export default PosthogSettings;
